import { makeStyles } from '@material-ui/core';
import { useState } from 'react';
import { getConfig } from '../../../util/configUtil';
import { useEffect } from 'react';
import { setSnackbar } from '../../../store/reducers/globals';
import { hasOneOfPermission, Permissions, sendUserAudit } from '../../../store/reducers/user';
import { AUDIT_TYPES } from '../../../util/auditUtil';
import { setTreatmentsBoardOpened } from '../../../store/reducers/patientContext';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

export const useStyles = makeStyles((theme) => ({
    iframe: {
        width: '100vw',
        height: '90vh',
        border: 'none',
        overflowX: 'hidden',
        overflowY: 'hidden',
    },
}));

export const LiveDashboard = ({ isAdminMode = false }) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const history = useHistory();

    const insightDashboard = getConfig('modules.insightDashboard', {});

    const path = '/view/live';
    const token = window.keycloak ? window.keycloak.token : window.auth.token;
    const refreshToken = window.keycloak ? window.keycloak.refreshToken : window.auth.refreshToken;
    const iFrameSource = `${insightDashboard?.url ?? ''}${path}?token=${encodeURIComponent(token)}&refreshToken=${encodeURIComponent(refreshToken)}`;

    const [init, setInit] = useState(false);

    const canOpenPt = dispatch(hasOneOfPermission([Permissions.AGYLE_CAN_OPEN_PATIENT_RECORD, Permissions.AGYLE_CAN_VIEW_ONLY]));

    useEffect(() => {
        if (init) {
            const token = window.keycloak ? window.keycloak.token : window.auth.token;
            const refreshToken = window.keycloak ? window.keycloak.refreshToken : window.auth.refreshToken;
            handleSendMessage({ type: 'SET_TOKEN', token, refreshToken });
            const handleMessage = (event) => {
                if (event?.data?.type === 'OPEN_PATIENT_CONTEXT' && event?.data?.data) {
                    const { data } = event.data;
                    const idTB = data.urlPath?.split(path)?.[1];
                    if (!canOpenPt) {
                        dispatch(
                            setSnackbar({
                                type: 'warning',
                                message: 'You do not have permission to view this patient record.',
                            }),
                        );
                        return;
                    }

                    console.log('idTB:', idTB);
                    dispatch(sendUserAudit({ patient: data.patient }, AUDIT_TYPES.OPEN_PATIENT_CONTEXT, { fromTreatmentsBoard: true }));

                    if (idTB) {
                        dispatch(setTreatmentsBoardOpened(idTB));
                    }
                    history.push('/patient-context/' + data.patient?._id);
                }
            };

            window.addEventListener('message', handleMessage);
            return () => window.removeEventListener('message', handleMessage);
        }
    }, [init]);

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.origin !== path) return;

            if (event?.data?.type === 'OPEN_PATIENT_CONTEXT' && event?.data?.data) {
                const { data } = event.data;

                if (!canOpenPt) {
                    dispatch(
                        setSnackbar({
                            type: 'warning',
                            message: 'You do not have permission to view this patient record.',
                        }),
                    );
                    return;
                }

                dispatch(sendUserAudit({ patient: data.patient }, AUDIT_TYPES.OPEN_PATIENT_CONTEXT, { fromLiveDashboard: true }));

                history.push('/patient-context/' + data.patient?._id);
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    useEffect(() => {
        if (init) {
            handleSendMessage({ type: 'SET_THEME', theme: window._getTheme() });

            if (isAdminMode) {
                handleSendMessage({ type: 'SET_LIVE_DASHBOARD_EDIT_MODE', isEditMode: true });
            }
        }
    }, [init, window._theme, isAdminMode]);

    const handleSendMessage = (body) => {
        const wn = document.getElementById('live-dashboard');
        if (!wn) return;
        const originUrl = new URL(wn.src).origin;

        setTimeout(() => {
            wn.contentWindow.postMessage(body, originUrl);
        }, 500);
    };

    return (
        <>
            <iframe
                id="live-dashboard"
                className={classes.iframe}
                src={iFrameSource}
                title="Treatments Board"
                onLoad={() => setInit(true)}
                onError={(e) => console.error('iFrame Error', e)}
                scrolling="no"
            />
        </>
    );
};
